import get from 'lodash.get';

import { emptyObject } from 'ui-components/default-props/empty';

export const selectFreightShipments = (state) => get(state, 'freightShipments', emptyObject);
export const selectFreightShipmentById = (state, props) => get(selectFreightShipments(state), props.freightShipmentId);
